import { render, staticRenderFns } from "./card-grid-item-rivoneed.vue?vue&type=template&id=ff01032e&scoped=true&"
import script from "./card-grid-item-rivoneed.vue?vue&type=script&lang=js&"
export * from "./card-grid-item-rivoneed.vue?vue&type=script&lang=js&"
import style0 from "./card-grid-item-rivoneed.vue?vue&type=style&index=0&id=ff01032e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff01032e",
  null
  
)

export default component.exports